// extracted by mini-css-extract-plugin
export default {"fitContainer":"TS-z","label":"US-z","selectField":"VS-z","select":"WS-z","disabled":"XS-z","archField":"YS-z"};